/**
 * You must this utils if your are using the property .src without the next/image component
 * Ex:
 * import gradientShapeMobile from './assets/images/gradient-shape-mobile.jpg';
 * const StyledHeroBanner = styled(HeroBanner)`
    background-image: url(${
      appendImageCDNToStaticUrl(gradientShapeMobile.src)
    });
    background-position: 0 0;
 * `
 */

var imageCDNPrefix = process.env.IMAGE_PREFIX_URL || '';

/**
 * @deprecated
 * Please upload your image to our CDN using the frontend-image-uploader app.
 */
var appendImageCDNToStaticUrl = function appendImageCDNToStaticUrl(imageSrc) {
  return "".concat(imageCDNPrefix).concat(imageSrc);
};
export default appendImageCDNToStaticUrl;